
const Utils = {
    redirect: function(url) {
        window.location.href = url;
    },

    open: function(url) {
        window.open(url, '_blank');
    },

    authorizationError: function() {
        window.location.href = '/403';
    },

    getQueryParameter: function(name) {
        let urlParams = new URLSearchParams(window.location.search);
        let param = urlParams.get(name);
        return param;
    }
};

exports.Utils = Utils;